<template>
    <v-container>
        <v-row class="mt-12">
            <v-col>
                <div
                    :class="{
                        'display-2': $vuetify.breakpoint.mdAndUp,
                        'display-1': $vuetify.breakpoint.smAndDown,
                    }"
                    class="font-weight-bold text-center"
                >
                    <br/>
                    <p>Nuestro equipo está preparando la formación.</p>
                    <br/>
                    <p>Nos pondremos en contacto cuando esté todo listo.</p>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" offset-md="8" md="2">
            </v-col>
            <v-col cols="12" md="2">
              <v-btn
                block
                color="secondary"
                @click="submit()"
              >
                IR A INMATIC
              </v-btn>
            </v-col>
          </v-row>
    </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PolicyDialogLink from "./PolicyDialogLink";
import PolicyPrivacity from "./PolicyPrivacity";
import { user as api_user } from "@/api/user";
import { STATUS } from "../../store/modules/me";

export default {
    name: "TrainingReady",
    components: {
        PolicyDialogLink,
        PolicyPrivacity,
    },
    data() {
        return {
            valid: false,
            submitting: false,
            form: {
                formation_companydb_num1: '',
                formation_companydb_num2: '',
                files: null,
                status: STATUS.ACTIVE,
            },
            requiredRule: [(v) => Boolean(v) || "required"],
            dragging_file: false,
        };
    },
    created() {
        this.setPrograms();
        this.fillForm();
    },
    methods: {
        previousStep() {
            this.$emit("previousStep");
        },
        dropFiles(e){
            if(this.form.files != null) {
                this.form.files.push(...Array.from(e.dataTransfer.files));
            } else {
                this.form.files = Array.from(e.dataTransfer.files);
            }
            this.dragging_file = false;
            e.preventDefault();
        },


        async submit() {
            this.submitting = true;
            try {
                const response = await api_user.setUserInfo(this.form);
                this.setUserData(response.data.results);
                await this.setCompanydbs();
                let companydbs = this.getCurrentCompany;
                this.$router.push('/' + companydbs.id + '/documents');
            } catch (error) {
                console.log(error);
            } finally {
                this.submitting = false;
            }
        },
        fillForm: function () {
            this.form.formation_companydb_num1 = this.userData.formation_companydb_num1;
            this.form.formation_companydb_num2 = this.userData.formation_companydb_num2;
        },
        ...mapActions({
            setUserData: "me/setUserData",
            setPrograms: "tutorial/setPrograms",
            setCompanydbs: 'setCompanydbs',
        }),
    },
    computed: {
        ...mapGetters({
            userData: "me/userData",
            programas: "tutorial/programs",
            getCurrentCompany: 'getCurrentCompany',
        }),
        program() {
            let that = this;
            let program = this.programas.filter(
                function(data){ return data.id == that.userData.selected_program }
            );
            return program[0];
        },
        formation_companydb_num_label() {
            let label = 'Num. Empresa ';
            if (this.program.value == 'contanet') {
                label = 'Ruta Empresa ';
            }
            label += this.program.name
            return label
        },
        error_companydb_num() {
            return false;
        },
    },
    watch: {
        userData: function () {
            this.fillForm();
        },
    },
};
</script>
<style scoped>
    
</style>
